import { getBuffer as getLogBuffer } from './logger';

/**
 * Prints a structured diagnostic snapshot when the host forces an AI bot retry.
 * Keeps the noisy log formatting out of useAIPlayer's main execution flow.
 *
 * @param {Object} params
 * @param {string} params.turnId
 * @param {Object} params.currentPlayerData
 * @param {boolean} params.moveInProgress
 * @param {number|null} params.aiMoveStartedAt
 * @param {string|null} params.lastExecutedAITurn
 * @param {string|null} params.host
 * @param {string} params.currentUser
 * @param {boolean} params.gameEnded
 * @param {string} params.screen
 * @param {number} params.poolSize
 * @param {Array<Object>} params.players
 */
export function logStuckBotDiagnostics({
  turnId,
  currentPlayerData,
  moveInProgress,
  aiMoveStartedAt,
  lastExecutedAITurn,
  host,
  currentUser,
  gameEnded,
  screen,
  poolSize,
  players,
}) {
  const cp = currentPlayerData;
  const elapsed = aiMoveStartedAt
    ? `(${((Date.now() - aiMoveStartedAt) / 1000).toFixed(1)}s ago)`
    : '';

  /* eslint-disable no-console */
  console.warn('[UNSTUCK] ══════════════════════════ BOT UNSTUCK ══════════════════════════');
  console.warn('[UNSTUCK] turnId          :', turnId);
  console.warn('[UNSTUCK] isAI / isBot    :', cp?.isAI, '/', cp?.isBot);
  console.warn('[UNSTUCK] bot_persona     :', cp?.bot_persona);
  console.warn('[UNSTUCK] markers in hand :', cp?.markers?.length, JSON.stringify(cp?.markers ?? []));
  console.warn('[UNSTUCK] moveInProgress  :', moveInProgress);
  console.warn('[UNSTUCK] aiMoveStartedAt :', aiMoveStartedAt, elapsed);
  console.warn('[UNSTUCK] lastExecAITurn  :', lastExecutedAITurn);
  console.warn('[UNSTUCK] host/me/isHost  :', host, '/', currentUser, '/', currentUser === host);
  console.warn('[UNSTUCK] gameEnded       :', gameEnded, '| screen:', screen);
  console.warn('[UNSTUCK] pool size       :', poolSize);
  console.warn('[UNSTUCK] players         :', players.map(p => ({ n: p.name, ai: p.isAI, mk: p.markers?.length, ci: p.colorIndex })));
  console.warn('[UNSTUCK] ── last 60 log entries ──────────────────────────────────────────');
  getLogBuffer().slice(-60).forEach(({ t, level, msg }) =>
    console.warn(`[UNSTUCK] [${level.toUpperCase()} -${((Date.now() - t) / 1000).toFixed(1)}s] ${msg}`)
  );
  console.warn('[UNSTUCK] ── forcing retry ──────────────────────────────────────────────');
  /* eslint-enable no-console */
}
